/** Normalize user-entered anchor to a safe HTML id (lowercase, hyphens). */
export function normalizeSectionAnchorId(raw: string): string {
  return String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

/** Returns `id` for a section wrapper when `section_anchor` is set in config. */
export function sectionIdAttr(config: Record<string, unknown> | null | undefined): string | undefined {
  const id = normalizeSectionAnchorId(String(config?.section_anchor ?? ''))
  return id || undefined
}
